import React, { Children } from 'react';
import { TypedElements } from '../../../util/types.util';
import Tab from './Tab';

interface TabsProps {
  children: TypedElements<typeof Tab>;
  padding?: boolean;
}

export default function Tabs({ children, padding = false }: TabsProps) {
  const tabs = Children.toArray(children);

  return (
    <ul role='tablist' className={`${padding ? 'content-x' : ''} mb-6 flex gap-6 rounded-2 bg-white`}>
      {tabs}
    </ul>
  );
}
